import Instance from "../general.instance";
import {
  USER,
  USER_LOV,
  USER_LOV_MRA,
  USER_STATUS,
  USER_VALIDATE_USERNAME,
  USER_VALIDATE_EMAIL,
  USER_CURRENT,
  USER_CHANGE_PASSWORD,
  USER_LOV_MRO,
  USER_LOV_USER_MRO,
  USER_ACTIVATE,
  USER_DEACTIVATE,
  USER_ACTIVATE_ALL,
  USER_DEACTIVATE_ALL,
  MRO_BY_USERLOGIN,
  HOME,
  HOME_STORE,
  HOME_TRX_STORE,
  HOME_TRX_STORE_DOWNLOAD,
  MEMBER,
  STORE,
  MIDDLE_INSTANCE,
  SYNC_INSTANCE
} from "../constants";

const MiddleInstance = new Instance(MIDDLE_INSTANCE);
const SyncInstance = new Instance(SYNC_INSTANCE);

const UserService = {
  create(data) {
    return MiddleInstance.post(USER, data);
  },
  getCurrent(params) {
    return MiddleInstance.query(USER_CURRENT, params);
  },
  update(data) {
    return MiddleInstance.put(USER, data);
  },
  changePassword(data) {
    return MiddleInstance.put(USER_CHANGE_PASSWORD, data);
  },
  getList(params, token, headers) {
    return MiddleInstance.query(USER, { params, ...token, headers });
  },
  getLov(params) {
    return MiddleInstance.query(USER_LOV, { params });
  },
  getLovMRA(params) {
    return MiddleInstance.query(USER_LOV_MRA, { params });
  },
  getDetail(id) {
    return MiddleInstance.fetch(USER, id);
  },
  getListStatus(params) {
    return MiddleInstance.query(USER_STATUS, { params });
  },
  delete(data) {
    return MiddleInstance.delete(USER, { data });
  },
  validateUsername(data, token) {
    return MiddleInstance.post(USER_VALIDATE_USERNAME, data, { ...token });
  },
  validateEmail(data, token) {
    return MiddleInstance.post(USER_VALIDATE_EMAIL, data, { ...token });
  },
  getLovMRO(params) {
    return MiddleInstance.query(USER_LOV_MRO, { params });
  },
  getLovUserMRO(params) {
    return MiddleInstance.query(USER_LOV_USER_MRO, { params });
  },
  mroByLogin(params) {
    return MiddleInstance.query(MRO_BY_USERLOGIN, { params });
  },
  getCounter(params, headers) {
    return MiddleInstance.query(HOME + "/counter", { params, headers });
  },
  getListStoreTRX(params, token) {
    return MiddleInstance.query(STORE + "/list-storeTrx", { params, ...token });
  },
  getListDueForReview(params, headers, token) {
    return MiddleInstance.query(HOME + "/listDueForReview", {
      params,
      headers,
      ...token
    });
  },
  getListDashboard() {
    return MiddleInstance.query(HOME_STORE);
  },
  getListTrxDashboard() {
    return MiddleInstance.query(HOME_TRX_STORE);
  },
  getDownload(params) {
    return MiddleInstance.query(HOME_TRX_STORE_DOWNLOAD, { params });
  },
  getListDueForReviewDownload(params) {
    return SyncInstance.query(MEMBER + "/export-listDueForReview", { params });
  },
  activateMultiple(data) {
    return MiddleInstance.put(USER_ACTIVATE, data);
  },
  deActivateMultiple(data) {
    return MiddleInstance.put(USER_DEACTIVATE, data);
  },
  activateAll(data) {
    return MiddleInstance.put(USER_ACTIVATE_ALL, data);
  },
  deactivateAll(data) {
    return MiddleInstance.put(USER_DEACTIVATE_ALL, data);
  },
  cancelReq() {
    return MiddleInstance.cancelRequest();
  }
};

export default UserService;
